
import './ssoLogin.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import sso from '../../service/sso';
import routing from './ssoLogin.routes';
import SsoLoginController from './ssoLogin.controller';

export default angular.module('module.ssoLogin', [
		uirouter,
		sso
	])
	.config(routing)
	.controller('SsoLoginController', SsoLoginController)
	.name;



// WEBPACK FOOTER //
// ./src/page/ssoLogin/index.js